import { AdvancedMarker, APIProvider, Map } from "@vis.gl/react-google-maps";
import React, { useEffect } from "react";
import Style from "./mapshowlocationscomponent.module.scss";

/**
 *
 * 
 */
export type IMapShowLocationsComponent = {
  uid: string,
  numberOnMap: number | undefined,
  lat: number,
  lng: number
  color: string,
}

interface MapComponentProps {
  onLocationSelected?: (uid: string) => void;
  locations: IMapShowLocationsComponent[]
}

const InnerMap: React.FC<MapComponentProps> = ({ locations }) => {

  //const map = useMap();

  useEffect(() => {
  }, []);

  return (
    <>
      <Map
        className={Style.map}
        style={{ minHeight: "100px", minWidth: "100px", height: "500px" }}
        mapId={'a'}
        defaultZoom={10}
        defaultCenter={{ lat: 53.17733483052828, lng: 7.762240042553961 }}
        gestureHandling={'greedy'}
        disableDefaultUI={false}
      >
        {locations.map((e1, index) =>
          <>
            {e1.lat && e1.lng &&
              <AdvancedMarker
                key={index}
                position={{ lat: e1.lat, lng: e1.lng }}
                onClick={(e) => { /*e.stop(); clicked(e1.uid)*/ /*document.getElementById(...).scrollIntoView()*/
                   /*window.location.hash = "#number" + e1.numberOnMap + "Auftrag" */
                   document.getElementById('number' + e1.numberOnMap + 'Auftrag')?.scrollIntoView()
                }}
                draggable={false}
              >
                <div style={{
                  backgroundColor: e1.color,
                  borderRadius: '50%',
                  width: '30px',
                  height: '30px',
                  color: 'white',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  {e1.numberOnMap}
                </div></AdvancedMarker>}
          </>
        )}
      </Map>
    </>
  );
}

const MapComponent: React.FC<MapComponentProps> = ({ locations }) => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_KEY!!;

  return (
    <APIProvider apiKey={googleMapsApiKey} solutionChannel='GMP_devsite_samples_v3_rgmautocomplete'>
      <InnerMap locations={locations} />
    </APIProvider>
  );
};

export default MapComponent;